export const isValidContainerNumber = (containerNumber: string): boolean => {
  return /[A-Z]{4}\d{7}$/.test(containerNumber)
}
